import type { BubblePointPressurePSIACalculator } from "../../d";
import { solutionGasRsoCalculator } from "./solutionGasRsoCalculator";

export const bubblePointPressurePSIACalculator: BubblePointPressurePSIACalculator =
  params => {
    const { gasSpecificGravity, solutionGasRsoAtReservoir } = params;
    const { a } = solutionGasRsoCalculator(params);
    // D72: =IF(D11>0,D11,18.2*((((J15/D8)^0.83)*10^D68)-1.4))
    const bubblePointPressurePSIA = gasSpecificGravity
      ? 18.2 *
        ((solutionGasRsoAtReservoir / gasSpecificGravity) ** 0.83 * 10 ** a -
          1.4)
      : 0;

    return {
      bubblePointPressurePSIA
    };
  };
